import { controls, grouped } from "../../controls";
import moment from "moment";

const rp2131 = {
  label: "ATM Reconcilliation 2",
  starting: true,
  url: "rp2131",
  pageLabel: "ATM Reconcilliation On Us",
  pageType: "history",
  filter: [
    ...controls.magicDateLabel({ label: "As On Date", width: "col-sm-1", target: "as_on_date" }),
    ...controls.magicDate({ dateType: "ontype", isRequired: true, name: "as_on_date", width: "col-sm-2" }),
    ...controls.magicDateLabel({ label: "", width: "col-sm-2" }),

   ...grouped.iterative("advance")

  ],
  form: [],

  history: {
    perPage: 10,
    reportHeader: "ATM Reconcilliation",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: false,
    textReportProps: {
      'Recon': {
        filename: `TPDCCB$pageData.as_on_date$O-01.RC`,
        format: {}
      },
    },
    displayColumns: [
      {
        Header: "STAN",
        accessor: "systraceno",
        widthRecon: { size: 6 }
      },
      {
        Header: "Card No",
        accessor: "cardno",
        widthRecon: { size: 19, padder: " ", align: "left" }
      },
      {
        Header: "RRN",
        accessor: "rrn",
        widthRecon: { size: 12, padder: "0", align: "right" }
      },
      {
        Header: "AC Type",
        accessor: "actype",
        // accessor: d=>d.actype=='11' ? '10' : d.actype=='1' ? '10' : d.actype=='0' ? '10' : d.actype,
        widthRecon: { size: 2 }
      },
      {
        Header: "AC No",
        accessor: "acno",
        widthRecon: { size: 18, padder: "0", align: "right" }
      },
      {
        Header: "AC Name",
        accessor: "acname",
        widthRecon: { size: 26, padder: " ", align: "left" }
      },
      {
        Header: "Branch Code",
        accessor: "branchcode",
        widthRecon: { size: 4 }
      },
      {
        Header: "Branch Name",
        accessor: "branchname",
        widthRecon: { size: 25, padder: " ", align: "left" }
      },
      {
        Header: "Tran Type",
        accessor: "Trntype",
        widthRecon: { size: 1 }
      },
      {
        Header: "CD Flag",
        accessor: "CDFlag",
        widthRecon: { size: 1 }
      },
      {
        Header: "Amount",
        accessor: "amount",
        widthRecon: { size: 15, padder: "0", align: "right" }
      },
      {
        Header: "Trn Date",
        accessor: "trndate",
        widthRecon: { size: 6 }
      },
      {
        Header: "Trn Time",
        accessor: "trntime",
        widthRecon: { size: 6 }
      },
      {
        Header: "Value Date",
        accessor: "valuedate",
        widthRecon: { size: 6 }
      },
      {
        Header: "Value Time",
        accessor: "valuetime",
        widthRecon: { size: 6 }
      },
      {
        Header: "Terminal ID",
        accessor: "terminalid",
        widthRecon: { size: 8, padder: " ", align: "left" }
      },
      {
        Header: "Location",
        accessor: "location",
        widthRecon: { size: 40, padder: " ", align: "left" }
      },
      {
        Header: "Respcode",
        accessor: "respcode",
        widthRecon: { size: 2 }
      }
    ]
  }
};

export default rp2131;